'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _find = require('lodash/find');var _find2 = _interopRequireDefault(_find);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');






var _containers = require('../../containers');


var _manageProperties = require('../../redux/modules/manageProperties');









var _userAuthentication = require('../../redux/modules/userAuthentication');




var _payments = require('../../redux/modules/payments');

var _messageModal = require('../../redux/modules/messageModal');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _contactUs = require('../../redux/modules/contactUs');
var _propertiesAnalytics = require('../../redux/modules/propertiesAnalytics');
var _shareModal = require('../../redux/modules/shareModal');

var _constants = require('../../constants');








var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkers = require('../../utils/checkers');
var _formatSEOData = require('../../utils/formatSEOData');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _formatMessage = require('../../utils/formatMessage');var _formatMessage2 = _interopRequireDefault(_formatMessage);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _checkUserIsAllowedToPublish = require('../../utils/checkUserIsAllowedToPublish');
var _facebookSDK = require('../../utils/facebookSDK');
var _upgradeRegularUserPackage = require('../../redux/modules/upgradeRegularUserPackage');
var _WhatsAppWidget = require('../../components/WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);
var _getManagePropertiesRowsPerPage = require('../../utils/getManagePropertiesRowsPerPage');var _getManagePropertiesRowsPerPage2 = _interopRequireDefault(_getManagePropertiesRowsPerPage);

var _ManagePropertiesPage = require('./ManagePropertiesPage.scss');var styles = _interopRequireWildcard(_ManagePropertiesPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var ManagePropertiesPage = function (_Component) {_inherits(ManagePropertiesPage, _Component);function ManagePropertiesPage() {var _temp, _this, _ret;_classCallCheck(this, ManagePropertiesPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { actionDone: false, showShareButton: false,
      isChangeActivityModalOpen: false,
      localPropertiesIds: [],
      foreignPropertiesIds: [],
      propertiesWithoutContactsIds: [] }, _this.

    componentWillMount = function () {var
      query = _this.props.location.query;var
      userProperties = _this.props.userProperties;

      if (!_this.props.userData && !query.code) {
        _this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.SIGN_IN });
      }
      if (
      _this.props.userData &&
      userProperties.loaded &&
      userProperties.propertiesIds &&
      userProperties.propertiesIds.length)
      {
        _this.performAnalyticsQueries(userProperties.propertiesIds);
      }
    }, _this.

    componentDidMount = function () {var _this$props =



      _this.props,userData = _this$props.userData,locale = _this$props.locale;
      if (userData) {
        var is_active = userData.is_agent ? userData.is_agent : undefined;
        _this.props.loadUserProperties({
          token: userData.access_token,
          data: {
            $limit: (0, _getManagePropertiesRowsPerPage2.default)(),
            $skip: 0,
            is_active: is_active,
            language: locale } });


      }var

      query = _this.props.location.query;
      if (query.code) {
        _this.props.authenticateWithCode(query.code);
      }

      if (query.id) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/home_details/' + query.id));
      }

      _this.todayDate = new Date();
    }, _this.




















































































    openDetailsPopup = function (propertyData) {
      _this.props.openDetailsPopup(propertyData);
      if (!_this.props.isMobile) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/manage_properties?id=' + propertyData.propertyId));
      }
    }, _this.
































    receiveSupportMessage = function (isAgent, errorMessage) {return (
        (0, _formatMessage2.default)(errorMessage || _this.props.translate('propertyDetails', 'cantMakeActive'), [
        (0, _constants.getSupportEmail)(isAgent),
        (0, _constants.getSupportEmail)(isAgent)]));}, _this.


    showErrorModal = function (message) {
      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('p', {
            className: styles.modalMessageWrapper,
            dangerouslySetInnerHTML: { __html: message } })) });




    }, _this.

    handleShareClick = function () {
      _this.props.hideMessageModal();
    }, _this.

    openJumpToTopModal = function (propertyData, isSecondJump) {var _this$props2 =
      _this.props,translate = _this$props2.translate,locale = _this$props2.locale;var _ref =








      propertyData || {},id = _ref.id,isActive = _ref.isActive,thumbnail = _ref.thumbnail,propertyType = _ref.property_type,is_autojump_enabled = _ref.is_autojump_enabled,is_promoted = _ref.is_promoted,is_top_promoted = _ref.is_top_promoted;

      var isPromoted = is_autojump_enabled || is_promoted || is_top_promoted;
      var localisedPropertyType = translate('propertyTypes', propertyType);

      var sharingClearedUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);
      var protocol = sharingClearedUrl.includes('://') ? '' : 'https://';
      var sharingUrl = '' + protocol + sharingClearedUrl;

      var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(
      propertyData,
      localisedPropertyType,
      translate('propertyDetails'),
      locale);

      var sharingPropertyData = { propertyId: id, isActive: isActive, sharingUrl: sharingUrl, sharingTitle: sharingTitle, thumbnail: thumbnail };var _this$props$userData =
      _this.props.userData,access_token = _this$props$userData.access_token,is_agent = _this$props$userData.is_agent;

      var handleSuccessShare = function handleSuccessShare(data) {
        _this.handleShareClick();
        var error = (0, _get2.default)(data, 'error_code') || (0, _get2.default)(data, 'error_message');

        if (!!data && !error) {
          _this.props.secondJumpToTop({ id: id, access_token: access_token });
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.share, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.secondMoveToTop);
        } else {
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.share, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.moveToTop);
        }
      };

      var handleUpgrade = function handleUpgrade() {
        _this.props.hideMessageModal();
        _this.props.openUpgradePackageModal(id);
      };

      var shareButton = _react2.default.createElement(_components.ShareFacebookButton, {
        onShareWindowClose: isSecondJump && handleSuccessShare,
        sharingData: sharingPropertyData,
        title: translate('propertyDetails', 'contacts', 'share').toString(),
        handleClick: _this.handleShareClick });


      var secondJumpShareButton = _this.renderFBShareButton(sharingUrl, handleSuccessShare);
      var postfix = _this.state.showShareButton ? '' : 'Bulk';

      var jumpToTopContent =
      _react2.default.createElement('div', null,
        _react2.default.createElement('p', { className: styles.jumpToTopTitle }, translate('propertyDetails', 'jumpToTopSuccessMessage' + postfix)),
        _react2.default.createElement('p', null, translate('propertyDetails', 'jumpToTopRecommendation' + postfix)));



      var secondJumpContent =
      _react2.default.createElement('div', { className: styles.secondJumpWrapper },
        _react2.default.createElement('div', { className: styles.secondJumpHeader },
          _react2.default.createElement('i', { className: 'icon icon-second-jump-to-top' },
            _react2.default.createElement('i', { className: 'path1' }),
            _react2.default.createElement('i', { className: 'path2' }),
            _react2.default.createElement('i', { className: 'path3' }),
            _react2.default.createElement('i', { className: 'path4' }),
            _react2.default.createElement('i', { className: 'path5' })),

          _react2.default.createElement('span', null, translate('propertyDetails', 'jumpToTop'), ' +')),

        _react2.default.createElement('div', { className: styles.secondJumpMessage }, translate('propertyDetails', 'secondJumpToTopMessage')));



      _this.props.openMessageModal({
        isCloseButtonInvisible: true,
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          isSecondJump ? secondJumpContent : jumpToTopContent,
          _react2.default.createElement('div', { className: styles.buttonsLine },
            isSecondJump ? secondJumpShareButton : _this.state.showShareButton && shareButton,
            _react2.default.createElement('button', {
                onClick: _this.props.hideMessageModal,
                className: _this.state.showShareButton ? 'btn btn-default' : 'btn btn-primary' },

              isSecondJump ? translate('cancel') : translate('publishProperty', 'ok'))),


          !isPromoted && !is_agent && _react2.default.createElement('div', { className: styles.buttonsLine },
            _react2.default.createElement('button', {
                onClick: handleUpgrade,
                className: 'btn ' + styles.upgradeButton },

              _react2.default.createElement('i', { className: 'icon icon-package-icon' },
                _react2.default.createElement('i', { className: 'path1' }),
                _react2.default.createElement('i', { className: 'path2' }),
                _react2.default.createElement('i', { className: 'path3' }),
                _react2.default.createElement('i', { className: 'path4' }),
                _react2.default.createElement('i', { className: 'path5' }),
                _react2.default.createElement('i', { className: 'path6' }),
                _react2.default.createElement('i', { className: 'path7' })),

              translate('propertyDetails', 'upgradePackage')))) });





    }, _this.

    publishProperty = function () {
      var propertiesData = (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties');
      var restriction = (0, _get2.default)(_this.props, 'userProperties.data.meta.restriction_to_add_properties.user_properties', {});

      if (!_this.props.userData.is_agent && propertiesData) {

        if (!(0, _checkUserIsAllowedToPublish.isUserAllowedToPublishPage)(_this.props.userData, propertiesData, restriction)) {
          var supportEmail = (0, _constants.getSupportEmail)(_this.props.userData.is_agent);
          return _this.props.openMessageModal({
            message:
            _react2.default.createElement('div', { className: 'contentMessage' },
              _react2.default.createElement('p', null, _this.props.translate('publishProperty', 'exceedNumberOfPublishedProperties'), ',', _react2.default.createElement('br', null),
                _this.props.translate('publishProperty', 'contactTo'), '\xA0',
                _react2.default.createElement('a', { href: 'mailto:' + supportEmail, className: 'link' }, supportEmail))) });




        }
      }
      return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/publish'));
    }, _this.

    publishForeignProperty = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign_publish'));}, _this.

    separatePropertiesWithAndWithoutContacts = function (selectedIds, userProperties) {var _selectedIds$reduce =
      selectedIds.reduce(
      function (acc, curr) {
        var property = userProperties.find(function (p) {return p.id === curr;});

        if (!property.contacts) {
          return acc;
        }

        var hasPrimaryContact = !(0, _isEmpty2.default)(property.contacts.primary) && !!property.contacts.primary.phone;
        var hasSecondaryContact = !(0, _isEmpty2.default)(property.contacts.secondary) && !!property.contacts.secondary.phone;

        var hasContacts = hasPrimaryContact || hasSecondaryContact;

        if (hasContacts) {
          acc.idsWithContacts.push(curr);
        } else {
          acc.idsWithoutContacts.push(curr);
        }

        return acc;
      },
      { idsWithContacts: [], idsWithoutContacts: [] }),idsWithContacts = _selectedIds$reduce.idsWithContacts,idsWithoutContacts = _selectedIds$reduce.idsWithoutContacts;


      return { idsWithContacts: idsWithContacts, idsWithoutContacts: idsWithoutContacts };
    }, _this.

    separateProps = function (selectedIds) {
      var userProperties = (0, _get2.default)(_this.props, 'userProperties.data.data') || [];
      var foreignPropIds = new Set(userProperties.
      filter(function (item) {return item.address.en.country_name !== 'Israel';}).
      map(function (item) {return item.id;}));

      return {
        foreignIds: selectedIds.filter(function (id) {return foreignPropIds.has(id);}),
        localIds: selectedIds.filter(function (id) {return !foreignPropIds.has(id);}) };

    }, _this.

    updateLocalAndForeignPropertiesActivity = function (localIds, foreignIds, activeStatus) {
      var config = {
        isAgent: _this.props.userData.isAgent,
        active: activeStatus,
        access_token: _this.props.userData.access_token };

      var promises = [];

      if (localIds.length) {
        promises.push(_this.props.updatePropertyActivity(Object.assign({},
        config, {
          ids: localIds })));

      }

      if (foreignIds.length) {
        promises.push(_this.props.updatePropertyActivity(Object.assign({},
        config, {
          ids: foreignIds })));

      }

      return Promise.all(promises);
    }, _this.

    updatePropertyActivity = function (_ref2) {var properties = _ref2.properties,activeStatus = _ref2.active;
      var ids = properties.map(function (property) {return property.id;});
      var isAgent = _this.props.userData.is_agent;

      var userProperties = (0, _get2.default)(_this.props, 'userProperties.data.data') || [];var _this$separateProps =

      _this.separateProps(ids),foreignIds = _this$separateProps.foreignIds,localIds = _this$separateProps.localIds;

      if (activeStatus) {
        var foreignUserProperties = _this.props.userProperties.data.meta.user_foreign_properties;
        var localUserProperties = _this.props.userProperties.data.meta.user_properties;
        var cannotActivateForeignPropeties =
        foreignIds.length + foreignUserProperties.active > foreignUserProperties.allowed;


        var localPropsLimitViolation =
        localIds.length + localUserProperties.active > localUserProperties.allowed;

        var localPropsAgentViolation =
        localIds.length && isAgent && !localUserProperties.allowed_until;

        var cannotActivateLocalProperties = localPropsLimitViolation || localPropsAgentViolation;
        if (
        cannotActivateForeignPropeties ||
        cannotActivateLocalProperties)
        {
          return _this.showErrorModal(_this.receiveSupportMessage(isAgent));
        }
      }

      var isPromoted = userProperties.some(function (item) {return !activeStatus && ids.includes(item.id) && (
        item.is_autojump_enabled || item.is_promoted);});


      var translate = _this.props.translate('managePage', 'propertyToggle', activeStatus ? 'activate' : 'deactivate');

      return _this.props.openMessageModal({
        isCloseButtonInvisible: true,
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('p', { className: styles.modalTitle }, translate('title')()),
          _react2.default.createElement('p', { className: styles.modalDescription }, translate(isPromoted ? 'promotedDescription' : 'description')()),

          _react2.default.createElement('div', { className: styles.buttonsLine },
            _react2.default.createElement('button', {
                className: 'btn btn-primary',
                onClick: function onClick() {return _this.props.hideMessageModal().then(function () {
                    if (activeStatus) {var _this$separatePropert =

                      _this.separatePropertiesWithAndWithoutContacts(ids, properties),idsWithoutContacts = _this$separatePropert.idsWithoutContacts;

                      if (idsWithoutContacts.length) {
                        _this.setState({
                          isChangeActivityModalOpen: true,
                          localPropertiesIds: localIds,
                          foreignPropertiesIds: foreignIds,
                          propertiesWithoutContactsIds: idsWithoutContacts });

                        return;
                      }
                    }
                    _this.updateLocalAndForeignPropertiesActivity(localIds, foreignIds, activeStatus);
                  });} },

              _this.props.translate('submit')),


            _react2.default.createElement('button', {
                onClick: _this.props.hideMessageModal,
                className: 'btn btn-default' },

              _this.props.translate('cancel')))) });





    }, _this.

    updatePropertyHighlighting = function (_ref3) {var ids = _ref3.ids,promote = _ref3.promote;return _this.props.updatePropertyHighlighting({
        ids: ids,
        promote: promote,
        access_token: _this.props.userData.access_token });}, _this.


    updateTopPromotionActivity = function (_ref4) {var ids = _ref4.ids,promote = _ref4.promote;return _this.props.activateTopPromotion({
        data: { ids: ids, enable: promote },
        token: _this.props.userData.access_token });}, _this.


    movePropertyToTop = function (id) {var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.property, _analyticsConstants.eventAction.moveToTop);
      _this.shouldRenderShareButton(param);
      _this.props.movePropertyToTop({
        id: id,
        access_token: _this.props.userData.access_token });

    }, _this.

    updateAutoJumpToTopActivity = function (data) {
      var token = (0, _get2.default)(_this.props, 'userData.access_token');
      _this.props.activateAutoJump({ data: data, token: token });
    }, _this.

    performAnalyticsQueries = function (propertiesIds) {
      _this.props.loadPropertiesAnalytics({
        ids: propertiesIds,
        action: _constants.analyticsEventAction.VIEW });

      _this.props.loadPropertiesAnalytics({
        ids: propertiesIds,
        action: _constants.analyticsEventAction.FAVOURITES });

      _this.props.loadPropertiesAnalytics({
        ids: propertiesIds,
        action: _constants.analyticsEventAction.SHOW_NUMBER });

    }, _this.

    fetchPropertyAnalytics = function (_ref5) {var userProperties = _ref5.userProperties,propertiesAnalytics = _ref5.propertiesAnalytics;
      if (userProperties.propertiesIds && userProperties.propertiesIds.length) {
        if (!propertiesAnalytics.loaded && !propertiesAnalytics.loading && !propertiesAnalytics.error) {
          _this.performAnalyticsQueries(userProperties.propertiesIds);
        }
      }
    }, _this.

    shouldRenderShareButton = function (param) {
      _this.setState(function (previousState) {return Object.assign({}, previousState, { showShareButton: param });});
    }, _this.
    openSuccessMessage = function () {
      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: styles.successPromoted },
          _react2.default.createElement('p', null, _this.props.translate('editProfile', 'formSent')),
          _react2.default.createElement('button', {
              onClick: _this.props.hideMessageModal,
              className: 'btn btn-primary' },

            _this.props.translate('editProfile', 'ok'))) });




    }, _this.

    handleSuccessPurchasePackage = function (paidProducts, setProcessOverlayState) {
      setProcessOverlayState(false);
      _this.openSuccessMessage();
    }, _this.

    handleCloseUpdateActivityModal = function () {
      _this.setState({
        isChangeActivityModalOpen: false,
        propertiesWithoutContactsIds: [],
        localPropertiesIds: [],
        foreignPropertiesIds: [] });

    }, _this.

    renderFBShareButton = function (shareUrl, callback) {
      var shareHandler = function shareHandler() {return (0, _facebookSDK.shareFB)(shareUrl, callback);};

      return (
        _react2.default.createElement('button', { className: styles.shareButton, onClick: shareHandler },
          _react2.default.createElement('span', null, _this.props.translate('managePage', 'share')),
          _react2.default.createElement('span', { className: 'icon icon-facebook' })));


    }, _this.

    renderPromotionFailedMessage = function (promotionType) {
      var translate = _this.props.translate('managePage', 'promotionFailedMessage');
      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.infoModal, 'contentMessage') },
          _react2.default.createElement('div', null, translate(promotionType + 'Message')),
          _react2.default.createElement('div', null,
            _react2.default.createElement('span', null, translate('moreInfo'), '\xA0'),
            _react2.default.createElement('span', {
                className: styles.contactUsButton,
                onClick: function onClick() {
                  _this.props.hideMessageModal();
                  _this.props.openContactUsModal();
                } },

              translate('contactUs')))));




    }, _this.

    renderPackagePromotion = function () {return (
        _react2.default.createElement('div', { className: styles.packagePromotionWrapper },











          _react2.default.createElement(_components.PackagePromotion, {
            translate: _this.props.translate('managePage'),
            packageName: 'highlight',
            iconName: 'promoted',
            promotions: (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.promotion', {}),
            packageStyle: styles.packagePromotion,
            labelStyle: styles.packagePromotionLabel,
            counter: styles.counter,
            isRtl: _this.props.isRtl }),


          _react2.default.createElement(_components.PackagePromotion, {
            translate: _this.props.translate('managePage'),
            packageName: 'top_promotion',
            iconName: 'top-promotion',
            promotions: (0, _get2.default)(_this.props, 'userProperties.data.meta.user_properties.top_promotion', {}),
            packageStyle: styles.packagePromotion,
            labelStyle: styles.packagePromotionLabel,
            counter: styles.counter,
            isRtl: _this.props.isRtl })));}, _this.




    renderButton = function () {
      var data = _this.props.userProperties && _this.props.userProperties.data && _this.props.userProperties.data.data;

      return data && data.length ?
      _react2.default.createElement('button', { onClick: _this.publishProperty, className: styles.addPublish }, _react2.default.createElement('span', null, 'Add')) :
      _react2.default.createElement('div', { className: styles.notProperty },
        _react2.default.createElement('div', { className: styles.publishTitle },
          _this.props.translate('header', 'publishProperty')),

        _react2.default.createElement('img', { alt: 'publish button', src: '/images/publish_btn.svg', className: styles.publishBtn, onClick: _this.publishProperty }));

    }, _this.

    renderUserScreen = function () {var _this$props3 =






      _this.props,isNative = _this$props3.isNative,_this$props3$userProp = _this$props3.userProperties,data = _this$props3$userProp.data,meta = _this$props3$userProp.meta;
      var properties = data ? data.data : [];
      var disabledPromotionAction = (0, _get2.default)(_this.props, 'userProperties.highlighting') ||
      (0, _get2.default)(_this.props, 'userProperties.jumping') ||
      (0, _get2.default)(_this.props, 'userProperties.autoJumpActivating') ||
      (0, _get2.default)(_this.props, 'userProperties.topPromotionActivating');

      var isCanManagePromotions = (0, _get2.default)(_this.props, 'userData.can_manage_promotions_as_regular_user');

      return (
        _react2.default.createElement('div', null,
          isCanManagePromotions && _this.renderPackagePromotion(),
          _react2.default.createElement(_components.OMPropertiesList, {
            isCanManagePromotions: isCanManagePromotions,
            updateAutoJumpToTopActivity: _this.updateAutoJumpToTopActivity,
            updatePropertyHighlighting: _this.updatePropertyHighlighting,
            updateTopPromotionActivity: _this.updateTopPromotionActivity,
            disabledPromotionAction: !!disabledPromotionAction,
            properties: properties,
            userProperties: _this.props.userProperties,
            activePropertiesLimit: meta && meta.user_properties.allowed,
            propertiesAnalytics: _this.props.propertiesAnalytics,
            loadSinglePropertyAnalytics: _this.props.loadSinglePropertyAnalytics,
            openChartOfViews: _this.props.openChartOfViews,
            closeChartOfViews: _this.props.closeChartOfViews,
            locale: _this.props.locale,
            translate: _this.props.translate,
            className: 'inManageProperties' + (_this.props.isMobile ? 'Mobile' : ''),
            openDetailsPopup: _this.openDetailsPopup,
            editProperty: _this.props.editProperty,
            editable: true,
            isMobile: _this.props.isMobile,
            updatePropertyActivity: _this.updatePropertyActivity,
            autoDeactivatedProperty: _this.state.autoDeactivatedProperty || null,
            movePropertyToTop: _this.movePropertyToTop,
            openMessageModal: _this.props.openMessageModal,
            hideMessageModal: _this.props.hideMessageModal,
            isModalShareOpen: _this.props.isModalShareOpen,
            hideModalShare: _this.props.hideModalShare,
            openModalShare: _this.props.openModalShare,
            openJumpToTopModal: _this.openJumpToTopModal,
            isRtl: _this.props.isRtl,
            promotedTitle: _this.props.translate('promotedPropertyTitle').toString(),
            suspendedTitle: _this.props.translate('suspendedPropertyTitle').toString(),
            suspendedTooltipMessage: _this.props.translate('suspendedTooltipMessage').toString(),
            modalShareId: _this.props.modalShareId,
            todayDate: _this.todayDate,
            openUpgradePackageModal: _this.props.openUpgradePackageModal,
            isNative: isNative }),


          _this.props.userData ? _this.renderButton() : null));


    }, _temp), _possibleConstructorReturn(_this, _ret);}ManagePropertiesPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if ((0, _get2.default)(this.props, 'location.query.id')) {return;}var userData = newProps.userData,_newProps$userAuthent = newProps.userAuthentication,isAuthenticationModalOpen = _newProps$userAuthent.isAuthenticationModalOpen,userIsAuthorized = _newProps$userAuthent.userIsAuthorized,userProperties = newProps.userProperties,userDataError = newProps.userDataError,propertiesAnalytics = newProps.propertiesAnalytics,locale = newProps.locale;if (this.props.userData && !userData) {this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.SIGN_IN });}if (this.props.userAuthentication.isAuthenticationModalOpen && !isAuthenticationModalOpen && !userIsAuthorized) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/'));}if (!this.props.userData && userData || userData && this.props.userData !== userData) {var is_active = userData.is_agent || undefined;if (!userProperties.loading) {this.props.loadUserProperties({ token: userData.access_token, data: { $limit: (0, _getManagePropertiesRowsPerPage2.default)(), $skip: 0, is_active: is_active, language: locale } });}if (userData.email && (0, _checkers.isTemporaryEmail)(userData.email)) {this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE });}}if (userDataError && userDataError !== this.props.userDataError) {if (userDataError.status === _constants.requestErrorStatusCodes.BAD_REQUEST) {_constants.storage.value.clear();this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.SIGN_IN });}}if (userProperties && userProperties.error && userProperties.error !== this.props.userProperties.error) {if (userProperties.error.status === _constants.requestErrorStatusCodes.TOKEN_VALIDATION_ERROR) {_constants.storage.value.clear();this.props.logOut();}}if (this.props.userProperties && !this.props.userProperties.error && newProps.userProperties.error) {var serverErrorId = (0, _get2.default)(newProps.userProperties.error.details.errorData, 'propertyId') || '';var serverErrorKey = (0, _get2.default)(newProps.userProperties.error.details, 'errorKey') || '';var supportMessage = this.receiveSupportMessage(userData.is_agent);var errorMissingContactInfoMessage = this.props.translate('propertyDetails', 'missing_contact_info').replace('{{ propertyId }}', serverErrorId);var activityMessage = serverErrorKey === _constants.ERROR_KEYS.MISSING_PROPERTY ? errorMissingContactInfoMessage + '<br>' + supportMessage : supportMessage;if (this.props.userProperties.highlighting) {this.props.openMessageModal({ message: this.renderPromotionFailedMessage('colorPromotion') });} else {this.showErrorModal(activityMessage);}}if (!this.props.userProperties.autoJumpActivateFailed && newProps.userProperties.autoJumpActivateFailed) {this.props.openMessageModal({ message: this.renderPromotionFailedMessage('autoJump') });}if (userProperties && userProperties.jumped && !this.props.userProperties.jumped && userProperties.jumpedProperty) {this.openJumpToTopModal(userProperties.jumpedProperty);}if (userData) {this.fetchPropertyAnalytics({ userProperties: userProperties, propertiesAnalytics: propertiesAnalytics });}this.updatePropertiesWithActions(newProps);};ManagePropertiesPage.prototype.updatePropertiesWithActions = function updatePropertiesWithActions(newProps) {var userProperties = newProps.userProperties;var query = this.props.location.query;if (userProperties && userProperties.loaded && query.property_id) {var properties = (0, _get2.default)(userProperties, 'data.data') || [];var propertyToMakeAction = (0, _find2.default)(properties, function (item) {return item.id === query.property_id;});if (propertyToMakeAction && query.action === _constants.managePropertyActions.DEACTIVATE && !this.state.actionDone && propertyToMakeAction.is_active) {this.setState({ autoDeactivatedProperty: query.property_id });}if (query.action === _constants.managePropertyActions.JUMP && !this.state.actionDone) {// cannot jump property
        if (propertyToMakeAction && (!propertyToMakeAction.is_active || propertyToMakeAction.is_autojump_enabled || !propertyToMakeAction.move_to_top)) {this.props.openMessageModal({ message: this.renderPromotionFailedMessage('jumpToTop') });} else {this.movePropertyToTop(propertyToMakeAction.id);}}this.setState({ actionDone: true });}};ManagePropertiesPage.prototype.
  render = function render() {var _cx;var _props =
    this.props,userProperties = _props.userProperties,location = _props.location,propertyTypes = _props.propertyTypes,sortedPropertyTypes = _props.sortedPropertyTypes,isNative = _props.isNative;
    var properties = userProperties && userProperties.data && userProperties.data.data ?
    userProperties.data.data :
    [];

    var isAgent = this.props.userData && this.props.userData.is_agent;

    var disabledPromotionAction = (0, _get2.default)(this.props, 'userProperties.highlighting') ||
    (0, _get2.default)(this.props, 'userProperties.jumping') ||
    (0, _get2.default)(this.props, 'userProperties.autoJumpActivating') ||
    (0, _get2.default)(this.props, 'userProperties.topPromotionActivating');

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(styles.managePage, 'pageHeight', (_cx = {}, _cx[
          styles.native] = isNative, _cx)) },


        _react2.default.createElement(_components.NotificationNoCompany, null),
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement(_reactHelmet2.default, {
            titleTemplate: this.props.translate('title', 'titleTemplate')(),
            title: this.props.translate('title', 'manageProperties')(),
            meta: [{ property: 'og:title', content: 'OnMap | ' + this.props.translate('header', 'manageProperties') }] }),

          isAgent ?
          _react2.default.createElement(_containers.ManagePropertiesForAgent, {
            handlePurchase: this.handleSuccessPurchasePackage,
            isMobile: this.props.isMobile,
            properties: properties,
            propertyTypes: propertyTypes,
            sortedPropertyTypes: sortedPropertyTypes,
            translate: this.props.translate,
            locale: this.props.locale,
            editProperty: this.props.editProperty,
            openDetailsPopup: this.openDetailsPopup,
            updatePropertyActivity: this.updatePropertyActivity,
            updatePropertyHighlighting: this.updatePropertyHighlighting,
            updateTopPromotionActivity: this.updateTopPromotionActivity,
            movePropertyToTop: this.movePropertyToTop,
            userData: this.props.userData,
            openMessageModal: this.props.openMessageModal,
            openContactUsModal: this.props.openContactUsModal,
            publishProperty: this.publishProperty,
            publishForeignProperty: this.publishForeignProperty,
            userProperties: this.props.userProperties,
            propertiesAnalytics: this.props.propertiesAnalytics,
            performAnalyticsQueries: this.performAnalyticsQueries,
            loadUserProperties: this.props.loadUserProperties,
            exportUserProperties: this.props.exportUserProperties,
            openChartOfViews: this.props.openChartOfViews,
            closeChartOfViews: this.props.closeChartOfViews,
            isRtl: this.props.isRtl,
            setCurrentPaginationStep: this.props.setCurrentPaginationStep,
            currentPaginationStep: (0, _get2.default)(this.props, 'userProperties.currentPaginationStep') || 1,
            loadSinglePropertyAnalytics: this.props.loadSinglePropertyAnalytics,
            updateAutoJumpToTopActivity: this.updateAutoJumpToTopActivity,
            shouldRenderShareButton: this.shouldRenderShareButton,
            disabledPromotionAction: !!disabledPromotionAction,
            isNative: isNative }) :

          this.renderUserScreen()),


        !isAgent && _react2.default.createElement(_containers.UpgradeRegularUserPackageModal, null),
        _react2.default.createElement(_components.UpdatePropertyActivityModal, {
          isOpen: this.state.isChangeActivityModalOpen,
          onClose: this.handleCloseUpdateActivityModal,
          propertiesWithoutContactsIds: this.state.propertiesWithoutContactsIds,
          localPropertiesIds: this.state.localPropertiesIds,
          foreignPropertiesIds: this.state.foreignPropertiesIds,
          translate: this.props.translate,
          isRtl: this.props.isRtl,
          updateLocalAndForeignPropertiesActivity: this.updateLocalAndForeignPropertiesActivity })));




  };return ManagePropertiesPage;}(_react.Component);


ManagePropertiesPage.displayName = 'ManagePropertiesPage';
ManagePropertiesPage.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  userProperties: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  loadUserProperties: _propTypes2.default.func,
  exportUserProperties: _propTypes2.default.func,
  editProperty: _propTypes2.default.func,
  updatePropertyActivity: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  activateTopPromotion: _propTypes2.default.func,
  movePropertyToTop: _propTypes2.default.func,
  secondJumpToTop: _propTypes2.default.func,
  activateAutoJump: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  isModalShareOpen: _propTypes2.default.bool,
  hideModalShare: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  propertyTypes: _propTypes2.default.array,
  sortedPropertyTypes: _propTypes2.default.object,
  openAuthenticationModal: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  location: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  openContactUsModal: _propTypes2.default.func,
  loadPropertiesAnalytics: _propTypes2.default.func,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  propertiesAnalytics: _propTypes2.default.object,
  openChartOfViews: _propTypes2.default.func,
  closeChartOfViews: _propTypes2.default.func,
  openUpgradePackageModal: _propTypes2.default.func,
  authenticateWithCode: _propTypes2.default.func,
  modalShareId: _propTypes2.default.string,
  userDataError: _propTypes2.default.object,
  buyRocketPromotion: _propTypes2.default.object,
  changeSelectedPayment: _propTypes2.default.func,
  openDetailsToInvoiceForm: _propTypes2.default.func,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    userData: state.userAuthentication.data,
    sortedPropertyTypes: state.propertyTypes.sorted,
    propertyTypes: state.propertyTypes.data,
    userDataError: state.userAuthentication.error,
    isNative: state.native.isNative,
    userProperties: state.manageProperties,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    userAuthentication: state.userAuthentication,
    propertiesAnalytics: state.propertiesAnalytics,
    isModalShareOpen: state.shareModal.isModalShareOpen,
    modalShareId: state.shareModal.id,
    buyRocketPromotion: state.buyRocketPromotion };};


var mapDispatchToProps = {
  loadUserProperties: _manageProperties.loadUserProperties,
  exportUserProperties: _manageProperties.exportUserProperties,
  editProperty: _manageProperties.editProperty,
  updatePropertyActivity: _manageProperties.updatePropertyActivity,
  updatePropertyHighlighting: _manageProperties.updatePropertyHighlighting,
  activateTopPromotion: _manageProperties.activateTopPromotion,
  movePropertyToTop: _manageProperties.movePropertyToTop,
  secondJumpToTop: _manageProperties.secondJumpToTop,
  activateAutoJump: _manageProperties.activateAutoJump,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  logOut: _userAuthentication.logOut,
  openContactUsModal: _contactUs.openContactUsModal,
  hideModalShare: _shareModal.hideModalShare,
  openModalShare: _shareModal.openModalShare,
  loadPropertiesAnalytics: _propertiesAnalytics.loadPropertiesAnalytics,
  loadSinglePropertyAnalytics: _propertiesAnalytics.loadSinglePropertyAnalytics,
  openChartOfViews: _propertiesAnalytics.openChartOfViews,
  closeChartOfViews: _propertiesAnalytics.closeChartOfViews,
  authenticateWithCode: _userAuthentication.authenticateWithCode,
  setCurrentPaginationStep: _manageProperties.setCurrentPaginationStep,
  openUpgradePackageModal: _upgradeRegularUserPackage.openUpgradePackageModal,
  changeSelectedPayment: _payments.changeSelectedPayment };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ManagePropertiesPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ManagePropertiesPage/ManagePropertiesPage.js
// module id = 3113
// module chunks = 0